import { render, staticRenderFns } from "./HighchartColumn.vue?vue&type=template&id=08b7ff97&scoped=true&"
import script from "./HighchartColumn.vue?vue&type=script&lang=js&"
export * from "./HighchartColumn.vue?vue&type=script&lang=js&"
import style0 from "./HighchartColumn.vue?vue&type=style&index=0&id=08b7ff97&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b7ff97",
  null
  
)

export default component.exports